import {Layers, TheRaveLayers} from "../../../view/TheRaveLayers";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheRave} from "../../../TheRave";
import {TimelineLite, TweenLite, Elastic} from "gsap";
import {TheRaveSound} from "../../../sound/TheRaveSound";

export class BigWinView extends PIXI.Container {

    private _layer: StageLayer;
    private _isPlaying: boolean;
    private _isLandscape: boolean;
    private _startImage: PIXI.Sprite;

    constructor() {
        super();
        this._layer = TheRaveLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
        this.position.set(360, 360);
        this._layer.addChild(this);

        this._startImage = new PIXI.Sprite(TheRave.assetLoader.getTextures("PhotosensitivityWarning")[0]);
        this._startImage.visible = false;
        this._startImage.anchor.set(0.5);
        this._startImage.alpha = 0;
        this.addChild(this._startImage);
    }

    public start(): TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => {
                TheRaveSound.startBigwinSound();
                this._startImage.visible = true
            },
            TheRave.fullScreenDimLayer.start(),
            TweenLite.to(this._startImage, {alpha: 1, duration: 1, ease: Elastic.easeInOut}),
            TweenLite.to(this, {alpha: 1, duration: 1, ease: Elastic.easeInOut})
        ]);
        return tl;
    }

    public getEndingAnimation(): void {
        new TimelineLite().add([
            ()=>{TheRaveSound.stopBigwinSound();},
            TweenLite.to(this, 0.4, {alpha: 0}),
            TheRave.fullScreenDimLayer.stop()
        ]);
    }

    public getLevelAnimation(level: number, duration: number, isEndLevel: boolean): TimelineLite {
        this._isPlaying = true;
        const usFix:string = (level === 1 && TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS)?"_US":"";

        const tl = new TimelineLite(),
            levelAnimation = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`bigwin${level}NORMAL${usFix}`)),
            levelAnimationBlend = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`bigwin${level}BLEND${usFix}`));
        levelAnimation.visible = false;
        levelAnimationBlend.visible = false;
        this.addChild(levelAnimationBlend);
        this.addChild(levelAnimation);
        let animNormalName: string = this.animationNameChecker(level, false);
        let animBlendName: string = this.animationNameChecker(level, true);
        tl.add([
            () => {
                this._startImage.visible = false;
                levelAnimation.visible = true;
                levelAnimationBlend.visible = true;
                levelAnimation.state.setAnimation(0,animNormalName,false);
                levelAnimationBlend.state.setAnimation(0,animBlendName,false);
                if(level>0){
                    TheRaveSound.stopSoundEffect(`bigwinLevel${level}`);
                }
                TheRaveSound.playSoundEffect(`bigwinLevel${level+1}`);
            },
            TweenLite.to(this, 0.2, {alpha: 1})
        ], 0);
        tl.add(()=>{
            this.removeChild(levelAnimation);
            this.removeChild(levelAnimationBlend);
            }, duration);
        return tl;
    }

    private animationNameChecker(currentLevel: number, isBlend: boolean): string {
        let animName: string = "animation";
        if (isBlend) {
            if (currentLevel === 2 || currentLevel === 3 || currentLevel === 4 || currentLevel ===5) {
                if (TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
                    animName = `L${currentLevel+1}_US_animation`;
                }
            }
        } else {
            if (currentLevel === 2) {
                if (TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
                    animName = `L${currentLevel + 1}_US_animation`;
                }
            }
        }
        return animName;
    }
}